import { FileUpload } from '@shared/models';
import { GridData } from '@shared/models/grid';

export interface FileUploadData extends FileUpload, GridData {
  id: number;
  extension?: string;
  commentSubtitle?: string;
  isImage?: boolean;
  isPrintInReport?: boolean;
}
